module.exports = {"130126100":"灵寿镇","130126101":"青同镇","130126102":"塔上镇","130126103":"陈庄镇","130126104":"慈峪镇","130126105":"岔头镇","130126200":"三圣院乡","130126201":"北洼乡","130126202":"牛城乡","130126203":"狗台乡","130126204":"南寨乡","130126205":"南燕川乡","130126206":"北谭庄乡","130126207":"寨头乡","130126208":"南营乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130126.json
// module id = 68
// module chunks = 0